import { getAllLoyaltyGenres, getAllLoyaltySites } from '@vista/omnichannel-components-domain';
import { MemberGender } from '@vista-digital/ocapi-types/v1';
import { sortDropdownOptionsAlphabetically } from '../../form/input/dropdown/utils';
export const getGenderOptions = (displayText) => {
    return [
        {
            text: displayText.femaleOptionLabel,
            value: MemberGender.Female
        },
        {
            text: displayText.maleOptionLabel,
            value: MemberGender.Male
        },
        {
            text: displayText.otherOptionLabel,
            value: MemberGender.Other
        }
    ];
};
export const getGenreOptions = (i18n) => {
    var _a;
    const genres = (_a = getAllLoyaltyGenres()) !== null && _a !== void 0 ? _a : [];
    return genres.map((genre) => ({
        text: i18n.translatable(genre.name),
        value: genre.id
    }));
};
export const getPrimarySiteFieldOptions = (i18n) => {
    var _a;
    const sites = (_a = getAllLoyaltySites()) !== null && _a !== void 0 ? _a : [];
    return sites
        .map((site) => ({
        text: i18n.translatable(site.name),
        value: site.id
    }))
        .sort(sortDropdownOptionsAlphabetically);
};
